import { Position } from "@xyflow/react";
import { CSSProperties } from "react";
import { InteractionType } from "../../models/interactions/Interaction";
import { TRIGGER_PARALLEL_OUTPUT_HANDLE_ID } from "../../models/interactions/Trigger";
import { HANDLE_SIZE } from "./SequenceNodeHandles";

export type HandleVariant = "default" | "true" | "false";
export type HandleType = "source" | "target";

export type HandleConfig = {
  id?: string;
  position: Position;
  variant: HandleVariant;
  extraStyle?: CSSProperties;
  colorOverride?: string;
};

export type SourceHandleConfig = HandleConfig & {
  wrapperStyle?: CSSProperties;
};

const IF_SOURCE_STYLE: CSSProperties = { top: "50%" };
const SWITCH_SOURCE_STYLE: CSSProperties = { top: "90px" };
const TRIGGER_SOURCE_STYLE: CSSProperties = { top: "56px" };

const IF_TRUE_WRAPPER_STYLE: CSSProperties = {
  left: "65%",
  bottom: "0px",
  transform: "translateX(-50%)",
  width: HANDLE_SIZE,
  height: HANDLE_SIZE,
};

const IF_FALSE_WRAPPER_STYLE: CSSProperties = {
  left: "35%",
  bottom: "0px",
  transform: "translateX(-50%)",
  width: HANDLE_SIZE,
  height: HANDLE_SIZE,
};

export const TARGET_HANDLE_CONFIG: HandleConfig = {
  position: Position.Left,
  variant: "default",
};

const DEFAULT_SOURCE_HANDLE_CONFIGS: SourceHandleConfig[] = [
  {
    position: Position.Right,
    variant: "default",
  },
];

const PARALLEL_SOURCE_HANDLE_CONFIGS: SourceHandleConfig[] = [
  {
    id: "primary-output",
    position: Position.Right,
    variant: "default",
  },
  {
    id: "secondary-output",
    position: Position.Bottom,
    variant: "default",
    colorOverride: "var(--pi-yellow)",
  },
];

const IF_SOURCE_HANDLE_CONFIGS: SourceHandleConfig[] = [
  {
    id: "source",
    position: Position.Right,
    variant: "default",
    extraStyle: IF_SOURCE_STYLE,
  },
  {
    id: "onTrue",
    position: Position.Bottom,
    variant: "true",
    wrapperStyle: IF_TRUE_WRAPPER_STYLE,
  },
  {
    id: "onFalse",
    position: Position.Bottom,
    variant: "false",
    wrapperStyle: IF_FALSE_WRAPPER_STYLE,
  },
];

const SWITCH_SOURCE_HANDLE_CONFIGS: SourceHandleConfig[] = [
  {
    id: "source",
    position: Position.Right,
    variant: "default",
    extraStyle: SWITCH_SOURCE_STYLE,
  },
];

const TRIGGER_SOURCE_HANDLE_CONFIGS: SourceHandleConfig[] = [
  {
    id: TRIGGER_PARALLEL_OUTPUT_HANDLE_ID,
    position: Position.Right,
    variant: "default",
    extraStyle: TRIGGER_SOURCE_STYLE,
    colorOverride: "var(--pi-yellow)",
  },
];

export function getSourceHandleConfigs(
  interactionType: InteractionType,
): SourceHandleConfig[] {
  switch (interactionType) {
    case InteractionType.ParallelSequence:
      return PARALLEL_SOURCE_HANDLE_CONFIGS;
    case InteractionType.If:
      return IF_SOURCE_HANDLE_CONFIGS;
    case InteractionType.Switch:
      return SWITCH_SOURCE_HANDLE_CONFIGS;
    case InteractionType.Trigger:
      return TRIGGER_SOURCE_HANDLE_CONFIGS;
    default:
      return DEFAULT_SOURCE_HANDLE_CONFIGS;
  }
}
